import React from 'react';

import { Block } from './Block.jsx';
import { EmptyPlaceholder } from '../layout/Builder.jsx';
import Utilities from './Utilities.jsx';

// #region BLOCK COMPONENT (-- DEPRECATED Use `ImageBlockV2` --)

function _ImageBlockV1Component(props) {
    const [id, setId] = React.useState(undefined);
    React.useEffect(() => { setId(`image-${new Date().getTime()}`) }, []);

    if (!props.builder && !props.imageTuples) {
        return null;
    }
    const containerStyle = { alignItems: props.imageAlignment, display: 'flex', flexDirection: 'column', height: '100%', width: '100%' };
    Utilities.copyObject(props.containerStyle, containerStyle);
    const imageStyle = {};
    Utilities.copyObject(props.imageStyle, imageStyle);
    const style = {};
    Utilities.copyObject(props.style, style);

    if (props.blockConfig) {
        if (props.blockConfig.block && props.blockConfig.block.borderRadius && props.blockConfig.block.borderRadius.value > 0 && props.blockConfig.block.borderRadius.unit) {
            imageStyle.borderRadius = `${props.blockConfig.block.borderRadius.value}${props.blockConfig.block.borderRadius.unit}`;
        }
        if (props.blockConfig.layout) {
            if (!props.inLayout && props.blockConfig.layout.height && props.blockConfig.layout.height.value > 0 && props.blockConfig.layout.height.unit) {
                style.height = undefined;
                imageStyle.height = '100%';
                imageStyle.width = undefined;
                containerStyle.height = `${props.blockConfig.layout.height.value}${props.blockConfig.layout.height.unit}`;
            } else if (props.inLayout && props.blockConfig.layout.maxHeight && props.blockConfig.layout.maxHeight.value > 0 && props.blockConfig.layout.maxHeight.unit) {
                imageStyle.maxHeight = `${props.blockConfig.layout.maxHeight.value}${props.blockConfig.layout.maxHeight.unit}`;
                style.maxHeight = undefined;
            }
            // imageStyle.width = '100%';
        }
    }
    let image;
    if (props.imageTuples) {
        const display = props.altText || props.display || (props.data && props.data.seoTitle) || props.config.company;
        image = (
            <ImageSrcSet
                className={props.imageClassName}
                builder={props.builder}
                config={props.config}
                data={{ alt: display, title: display }}
                extension={props.image && props.image.extension}
                imageId={props.imageId}
                imageTuples={props.imageTuples}
                serverSide={id == undefined}
                style={imageStyle}
                onLoad={props.onLoad} />
        );
    }
    if (props.link && props.link.length > 0) {
        image = <a href={props.link} style={{ maxHeight: '100%', maxWidth: '100%' }} target={props.newWindow ? '_blank' : undefined}>{image}</a>
    }
    let className = props.className || '';
    if (!props.inLayout) {
        if (props.className) {
            className += ' ';
        }
        className += 'cont--kit__content';
    }
    let content = (
        <div className={className} style={style}>
            <div style={containerStyle}>
                {image}
                {
                    props.builder &&
                    image == undefined &&
                    <EmptyPlaceholder />
                }
            </div>
        </div>
    );
    if (props.wrapperStyle) {
        content = <div className="cont--kit__wrapper" style={props.wrapperStyle}>{content}</div>
    }
    return content;
}
const ImageBlockV1Component = withTupleGeneration(_ImageBlockV1Component);
const ImageBlockV1 = { Component: ImageBlockV1Component };

// #endregion BLOCK COMPONENT

// #region BLOCK COMPONENT V2

function _ImageBlockV2Component(props) {
    const [id, setId] = React.useState(undefined);
    React.useEffect(() => { setId(`image-${new Date().getTime()}`) }, []);

    if (!props.builder && !props.imageTuples && !props.imageUrl && !props.imageContent) {
        return null;
    }
    let hasPercentageWidth = false;
    const imageStyle = {};
    const sizes = {};
    Utilities.copyObject(props.imageStyle, imageStyle);
    Utilities.copyObject(props.hoverImageStyle, imageStyle);
    const style = { display: 'block', fontSize: 0, lineHeight: 1, textAlign: 'center' };
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit(style, props, undefined, (propName, propValue, propUnit) => {
        switch (propName) {
            case 'alignItems':
                if (!props.inLayout) {
                    style.textAlign = propValue || 'center';
                }
                return true;
            case 'isCropped':
            case 'paddingBottom':
            case 'paddingLeft':
            case 'paddingRight':
            case 'paddingTop':
                return true;
            case 'minWidth':
            case 'width':
                sizes[propName] = propValue;
                if (props.inLayout && propUnit == '%') {
                    // Images inside layout containers with percentage width need to be handled differently
                    hasPercentageWidth = true;

                    // Only apply the percentage width to the wrapper if not in the builder, since the builder container receives the width otherwise (so the width is calculate correctly)
                    return props.builder;
                }
            // Intentional fallthrough
            case 'height':
            case 'maxHeight':
            case 'minHeight':
                sizes[propName] = propValue;
                if (propValue && propUnit) {
                    imageStyle[propName] = `${propValue}${propUnit}`;
                }
                return true;
            case 'maxWidth':
                sizes[propName] = propValue;
                break;
        }
    });
    // Remove any padding introduced from the kit
    layoutStyles.style.paddingBottom = undefined;
    layoutStyles.style.paddingLeft = undefined;
    layoutStyles.style.paddingRight = undefined;
    layoutStyles.style.paddingTop = undefined;

    if (layoutStyles.containerStyle) {
        if (layoutStyles.containerStyle.maxWidth) {
            hasPercentageWidth = props.inLayout && layoutStyles.containerStyle.maxWidth.endsWith('%');
            if (props.builder && props.inLayout && !hasPercentageWidth) {
                // When in builder, special handling of images inside of layouts without percentage width (nesting issues with the builder container)
                imageStyle.maxWidth = layoutStyles.containerStyle.maxWidth;
            } else if (!props.inLayout && !hasPercentageWidth) {
                // Images not inside layouts or those without a percentage apply the max width to the image itself
                imageStyle.maxWidth = layoutStyles.containerStyle.maxWidth;
            } else if (!props.builder) {
                // When not in builder, images inside layout containers with percentage widths apply the max width to the wrapper, otherwise it is applied to the builder container (so the width is calculated correctly)
                layoutStyles.style.maxWidth = layoutStyles.containerStyle.maxWidth;
            }
            // Clear the max width value at the kit wrapper level to prevent any funny business
            layoutStyles.containerStyle.maxWidth = undefined;
        }
        if (layoutStyles.containerStyle.width) {
            if (!hasPercentageWidth) {
                hasPercentageWidth = props.inLayout && layoutStyles.containerStyle.width.endsWith('%');
            }
            if (props.builder && props.inLayout && !hasPercentageWidth) {
                // When in builder, special handling of images inside of layouts without percentage width (nesting issues with the builder container)
                imageStyle.width = layoutStyles.containerStyle.width;
            } else if (!props.inLayout && !hasPercentageWidth) {
                // Images not inside layouts or those without a percentage apply the width to the image itself
                imageStyle.width = layoutStyles.containerStyle.width;
            } else if (!props.builder) {
                // When not in builder, images inside layout containers with percentage widths apply the  width to the wrapper, otherwise it is applied to the builder container (so the width is calculated correctly)
                layoutStyles.style.width = layoutStyles.containerStyle.width;
            }
            // Clear the width value at the kit wrapper level to prevent any funny business
            layoutStyles.containerStyle.width = undefined;
        }
    }
    if (props.builder) {
        if (props.inLayout) {
            layoutStyles.style.marginBottom = undefined;
            layoutStyles.style.marginTop = undefined;
        }
        if (hasPercentageWidth) {
            // When in builder, images inside layout containers with percentage widths apply margins to the builder container (since that's where the width values live and margins should NOT be included in the width calculations)
            layoutStyles.style.marginLeft = undefined;
            layoutStyles.style.marginRight = undefined;
        }
    }
    if (props.disabled) {
        layoutStyles.style.pointerEvents = 'none';
    }
    if (layoutStyles.style.maxHeight) {
        // Fix so the image doesn't spill out of the container vertically
        imageStyle.maxHeight = layoutStyles.style.maxHeight;
    }

    const display = props.alt || (props.data && props.data.seoTitle) || (props.config && props.config.company);
    let image;
    if (props.imageTuples) {
        image = (
            <ImageSrcSet
                className={props.imageClassName}
                builder={props.builder}
                config={props.config}
                data={{ alt: display, title: display }}
                extension={props.image && props.image.extension}
                imageId={props.imageTuples.length > 0 && props.imageTuples[0].url}
                imageTuples={props.imageTuples}
                serverSide={id == undefined}
                style={imageStyle}
                onLoad={props.onLoad} />
        );
    } else if (props.imageUrl) {
        if (!imageStyle.maxHeight) {
            imageStyle.maxHeight = '100%';
        }
        if (!imageStyle.maxWidth) {
            imageStyle.maxWidth = '100%';
        }
        if (!props.builder && !props.config.canDownloadImages) {
            imageStyle.pointerEvents = 'none';
        }
        image = <img alt={display} src={props.imageUrl} style={imageStyle} />
    } else {
        image = props.imageContent;
    }

    if (!props.builder && props.hoverEffectVisible) {
        image = <span style={props.hoverStyle} onMouseEnter={props.onHoverStart} onMouseLeave={props.onHoverEnd}>{image}{props.hoverEffect}</span>
    }
    if (props.link && props.link.length > 0) {
        image = <a href={props.link} style={{ display: 'block', maxHeight: '100%', maxWidth: '100%' }} target={props.newWindow ? '_blank' : undefined}>{image}</a>
    }
    let className = 'image2';
    if (props.className) {
        className += ` ${props.className}`;
    }
    if (!props.inLayout) {
        className += ' cont--kit__content';
    }
    let placeholder;
    if (props.builder) {
        if (image == undefined) {
            placeholder = <EmptyPlaceholder />
        } else if (sizes.height == '0' || sizes.maxHeight == '0' || sizes.maxWidth == '0' || sizes.width == '0') {
            placeholder = <EmptyPlaceholder />
        }
    }
    let content = (
        <div className={className} style={layoutStyles.style}>
            {image}
            {placeholder}
        </div>
    );
    // Images inside layout containers with percentage widths need to be placed such that the width is at the top most level, so we don't add the kit wrapper in that case
    if (layoutStyles.containerStyle && !props.inLayout && !hasPercentageWidth) {
        content = <div className="cont--kit__wrapper" style={layoutStyles.containerStyle}>{content}</div>
    }
    return content;
}
const ImageBlockV2Component = withHoverEffects(withTupleGeneration(_ImageBlockV2Component, false), 'block');
const ImageBlockV2 = { Component: ImageBlockV2Component };

// #endregion BLOCK COMPONENT V2

// #region IMAGE SRC SET

function ImageSrcSet(props) {
    let dataSrc, dataSrcSet, src;
    if (props.imageTuples) {
        if (props.extension == 'gif') {
            src = props.imageTuples[0].url;
        } else {
            const index = props.imageTuples.length - 1;
            dataSrcSet = props.imageTuples.map(function (d, i) {
                if (i == index) {
                    dataSrc = d.url;
                    // if (props.builder || props.serverSide) {
                    //     src = dataSrc;
                    // }
                }
                return `${d.url} ${d.size}w`;
            });
            if (props.builder || props.serverSide) {
                src = props.imageTuples[0].url;
            }
        }
    }
    const _initialClassName = (className) => {
        let _className = className;
        if (!props.isAsync && (props.builder || !props.serverSide)) {
            if (_className && _className.length > 0) {
                _className = `lazyload ${_className}`;
            } else {
                _className = 'lazyload';
            }
        }
        return _className;
    }
    const className = _initialClassName(props.className);
    const data = props.data || {};
    const imageRef = React.useRef(undefined);
    React.useEffect(() => {
        if (!imageRef || !imageRef.current) {
            return;
        }
        let className = _initialClassName();
        if (!className) {
            return;
        }
        if (props.className) {
            className += ` ${props.className}`;
        }
        imageRef.current.className = className;
    }, [props.imageId]);

    const style = props.style ? { ...props.style } : {};
    if (!props.builder && !props.config.canDownloadImages) {
        style.pointerEvents = 'none';
    }
    return (
        <img ref={imageRef}
            className={className}
            data-sizes="auto"
            data-src={dataSrc}
            data-srcset={dataSrcSet ? dataSrcSet.join(', ') : undefined}
            src={src}
            style={style}
            onLoad={props.onLoad}
            {...data} />
    );
}

// #endregion IMAGE SRC SET

// #region UTILITIES

function withHoverEffects(WrappedComponent, configGroup) {
    return function (props) {
        const [hover, setHover] = React.useState(false);
        const handleMouseEnter = () => setHover(true);
        const handleMouseLeave = () => setHover(false);

        const hoverStyle = { display: 'inline-block', height: '100%', position: 'relative' };
        let hoverEffect, hoverEffectVisible, hoverImageStyle;
        if (props.blockConfig && props.blockConfig[configGroup] && props.blockConfig[configGroup].hoverEffect) {
            const transition = 'all .2s ease-in-out';
            switch (props.blockConfig[configGroup].hoverEffect) {
                case '1':
                    if (props.blockConfig[configGroup].hoverColor) {
                        hoverEffect = <div style={{ backgroundColor: props.blockConfig[configGroup].hoverColor, height: '100%', left: 0, opacity: hover ? 1 : 0, position: 'absolute', top: 0, transition, width: '100%' }} />
                        hoverEffectVisible = true;
                    }
                    break;
                case '2':
                    if (props.blockConfig[configGroup].hoverScale) {
                        hoverStyle.scale = hover ? props.blockConfig[configGroup].hoverScale : '1.0';
                        hoverStyle.transition = transition;
                        hoverEffectVisible = true;
                    }
                    break;
                case '3':
                    if (props.blockConfig[configGroup].hoverZoom) {
                        hoverImageStyle = {
                            overflow: 'clip',
                            overflowClipMargin: 'content-box',
                            scale: hover ? props.blockConfig[configGroup].hoverZoom : '1.0',
                            transition
                        };
                        hoverStyle.overflow = 'hidden';
                        hoverEffectVisible = true;
                    }
                    break;
            }
        }
        return (
            <WrappedComponent
                hover={hover}
                hoverEffect={hoverEffect}
                hoverEffectVisible={hoverEffectVisible}
                hoverImageStyle={hoverImageStyle}
                hoverStyle={hoverStyle}
                onHoverEnd={handleMouseLeave}
                onHoverStart={handleMouseEnter}
                {...props}>
                {props.children}
            </WrappedComponent>
        )
    }
}

const defaultImageSize = 1024
function withMediaQueryImageSize(WrappedComponent) {
    return function (props) {
        const [imageSize, setImageSize] = React.useState(props.builder ? 1920 : undefined);
        React.useEffect(() => {
            if (props.builder) {
                return;
            }
            if (!window || !window.getComputedStyle || !document || !document.body) {
                setImageSize(defaultImageSize);
                return;
            }
            const value = window.getComputedStyle(document.body).getPropertyValue('--mobile-image-size');
            if (value) {
                setImageSize(value);
            } else {
                setImageSize(defaultImageSize);
            }
            // console.log(`image size: ${value}`);
        }, []);
        return <WrappedComponent imageSize={imageSize} {...props}>{props.children}</WrappedComponent>
    }
}

function withTupleGeneration(WrappedComponent, processStyleConfig) {
    return function (props) {
        const [imageTuples, setImageTuples] = React.useState(undefined);
        const generateImageTuples = () => {
            if (!props.image && !props.defaultUrl) {
                setImageTuples(undefined);
                return;
            }
            const tuples = Image.sizes.map(function (d) {
                let url;
                if (props.transform) {
                    url = Image.url(props.image, d, d, props.transform, props.defaultUrl, props.config && props.config.backgroundColor);
                } else if (props.blockConfig && props.blockConfig.layout && props.blockConfig.layout.isCropped != false) {
                    url = Image.url(props.image, d, d, 'c_fill', props.defaultUrl);
                } else {
                    url = Image.url(props.image, d, d, 'c_fit', props.defaultUrl, props.config && props.config.backgroundColor);
                }
                return { size: d, url: url };
            });
            setImageTuples(tuples);
        }
        React.useEffect(() => {
            generateImageTuples();
        }, []);
        React.useEffect(() => {
            generateImageTuples();
        }, [props.blockConfig.layout.isCropped, props.imageId]);

        if (processStyleConfig == false) {
            return <WrappedComponent {...props} imageTuples={imageTuples}>{props.children}</WrappedComponent>
        }

        const style = { display: 'block', fontSize: 0, lineHeight: 1, textAlign: 'center' };
        if (props.inLayout) {
            style.minWidth = '100%';
        }
        let alignItems = props.imageAlignment || 'center';
        let width;
        const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit(style, props, undefined, (propName, propValue, propUnit) => {
            if (props.blockPropsHandler && props.blockPropsHandler(style, propName, propValue, propUnit)) {
                return true;
            }
            switch (propName) {
                case 'alignItems':
                    if (!props.inLayout) {
                        alignItems = propValue;
                    }
                    return true;
                case 'height':
                    return props.inLayout;
                case 'hoverColor':
                case 'hoverEffect':
                case 'hoverScale':
                case 'hoverZoom':
                case 'isCropped':
                    return true;
                case 'maxHeight':
                    if (props.inLayout && propValue && propValue.length > 0) {
                        style.minWidth = 'unset';
                    }
                    return !props.inLayout;
                case 'width':
                    if (propValue && propValue.length > 0) {
                        width = `${propValue}${propUnit}`;
                    }
                    return true;
            }
        });
        Utilities.copyObject(props.style, layoutStyles.style);

        const imageStyle = {};
        Utilities.copyObject(props.imageStyle, imageStyle);
        if (props.builder) {
            if (props.inLayout) {
                if (layoutStyles.style.maxHeight) {
                    imageStyle.maxHeight = layoutStyles.style.maxHeight;
                }
            } else if (width) {
                imageStyle.width = width;
            }
            layoutStyles.style.pointerEvents = 'none';
        } else if (width) {
            if (props.inLayout) {
                layoutStyles.style.minWidth = 'unset';
                layoutStyles.style.width = width;
            } else {
                imageStyle.width = width;
            }
        }
        return (
            <WrappedComponent
                {...props}
                imageAlignment={alignItems}
                imageId={imageTuples && imageTuples.length > 0 ? imageTuples[0].url : props.imageId}
                imageStyle={imageStyle}
                imageTuples={imageTuples}
                style={layoutStyles.style}
                wrapperStyle={layoutStyles.containerStyle}>
                {props.children}
            </WrappedComponent>
        );
    }
}
const Image = {
    cellStyles: (props) => {
        let style = {};
        if (props.style) {
            Utilities.copyObject(props.style, style);
        } else {
            style = { display: 'block', fontSize: 0, lineHeight: 1, textAlign: 'center' };
            if (props.inLayout) {
                style.minWidth = '100%';
            }
        }
        if (props.builder) {
            style.pointerEvents = 'none';
        }
        let imageAlignment = props.imageAlignment || 'center';
        if (props.blockConfig && props.blockConfig.layout) {
            if (props.inLayout) {
                imageAlignment = props.alignment || 'center';
            } else if (props.blockConfig.layout.height && props.blockConfig.layout.height.value && props.blockConfig.layout.height.value.length > 0) {
                switch (props.blockConfig.layout.alignItems) {
                    case 'left':
                        imageAlignment = 'flex-start';
                        break;
                    case 'right':
                        imageAlignment = 'flex-end';
                        break;
                    default:
                        imageAlignment = props.blockConfig.layout.alignItems || 'center';
                        break;
                }
            }
        }
        let imageStyle = props.imageStyle || {};
        Utilities.copyObject(props.hoverImageStyle, imageStyle);
        const contentStyle = { alignItems: imageAlignment, display: 'flex', flexDirection: 'column', height: '100%', width: 'max-content' };
        if (props.inLayout) {
            contentStyle.width = '100%';

            if (style.maxHeight) {
                imageStyle.maxHeight = style.maxHeight
                style.maxHeight = undefined;
                // if (!props.editor) {
                //     style.width = undefined;
                // }
            }
        }
        if (imageStyle.width) {
            contentStyle.margin = Block.marginForAlignment(imageAlignment);
            if (props.builder && !props.inLayout && imageStyle.width.indexOf('%') > 0) {
                contentStyle.width = '100%';
            } else {
                contentStyle.width = imageStyle.width;
            }
            imageStyle.width = '100%';
        } else if (!imageStyle.height) {
            contentStyle.width = '100%';
        }
        if (style.width) {
            imageStyle.width = '100%'
        }
        return { contentStyle, imageStyle, style };
    },
    sizes: [1920, 1600, 1366, 1024, 768, 640, 320],
    url: function (image, height, width, transforms, defaultUrl, backgroundColor) {
        if (!image || !image.id || image.id.length == 0) {
            return defaultUrl;
        }

        const queryParams = [];
        if (image.extension != 'svg' && image.extension != 'gif') {
            if (width != undefined) {
                queryParams.push(`w_${width}`);
            }
            if (height != undefined) {
                queryParams.push(`h_${height}`);
            }
            let _transforms = transforms;
            if (queryParams.length > 0 && (!_transforms || _transforms.length == 0)) {
                queryParams.push('c_fit');
            }
            if (_transforms == 'c_pad' && image.extension != 'png' && backgroundColor && backgroundColor.length > 0) {
                _transforms = `c_pad,b_${backgroundColor}`;
            }
            if (_transforms && _transforms.length > 0) {
                queryParams.push(_transforms);
            }
        }
        let joinedParams = queryParams.join(',');
        if (queryParams.length > 0) {
            joinedParams += `/${image.id}`;
        } else {
            joinedParams += image.id;
        }

        const cdnUrl = 'https://cdn.artcld.com/img/';
        return `${cdnUrl}${joinedParams}.${image.extension}`;
    }
}

// #endregion UTILITIES

export default Image;
export {
    ImageBlockV1,
    ImageBlockV2,
    ImageSrcSet,
    withHoverEffects,
    withMediaQueryImageSize,
    withTupleGeneration
};